import React from 'react';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';
import ArrowForwardRounded from '@material-ui/icons/ArrowForwardRounded';

import classes from './styles.module.css';
import IconButton from '../Button/Icon';
import { isEmptyList, mod, path } from '../../utils';
import FewStepsAway from '../Banners/components/FewStepsAway';
import HotelOwners from '../Banners/components/HotelOwners';
import Testimonial from '../Banners/components/Testimonial';

const CARD_TYPES = { MAIN: 'main', LEFT: 'left', RIGHT: 'right', HIDDEN: 'hidden' };

export default class Carousel extends React.Component {

    interval;
    state = {
        index: path(this.props, 'initialIndex', Math.floor(Math.random() * this.props.components.length)),
    }

    componentDidMount = () => this.startCarousel();

    startCarousel = () => this.interval = setInterval(this.shift(false), 4000);

    stopCarousel = () => this.interval && clearInterval(this.interval);

    shift = bool => () => this.setState(pState => ({ index: mod(pState.index + (bool ? 1 : -1), this.props.components.length) }));

    render = () => {
        const { height, width, lateralProps, style, components } = this.props;
        return <div style={{ height: height, ...style }} className={classes.container} onMouseEnter={this.stopCarousel} onMouseLeave={this.startCarousel}>
            <div className={`${classes.buttonContainer} ${classes.left}`} onClick={this.shift(true)}>
                <IconButton className={classes.button} backgroundColor='#fff'><ArrowBackRounded /></IconButton>
            </div>
            <div className={classes.content} style={{ width: width + 2 * lateralProps.offset }}>
                {!isEmptyList(components) && components.map((Component, index) =>
                    <Component className={classes.card} style={this.calculateStyle(index)} />
                )}
            </div>
            <div className={`${classes.buttonContainer} ${classes.right}`} onClick={this.shift(false)}>
                <IconButton className={classes.button} backgroundColor='#fff'><ArrowForwardRounded /></IconButton>
            </div>
        </div>;
    }

    getCardType = index => {
        if (index === this.state.index) return CARD_TYPES.MAIN;
        else if (index === mod(this.state.index - 1, this.props.components.length)) return CARD_TYPES.LEFT;
        else if (index === mod(this.state.index + 1, this.props.components.length)) return CARD_TYPES.RIGHT;
        else return CARD_TYPES.HIDDEN;
    }

    calculateStyle = index => {
        const { width, height } = this.props;
        const { scale, offset, opacity } = path(this.props, 'lateralProps', { offset: 25, scale: 0.75, opacity: 0.5 });

        let mOffset, mZIndex, mScale, mOpacity;
        switch (this.getCardType(index)) {
            default:
            case CARD_TYPES.MAIN: mZIndex = 10; mScale = 1; mOpacity = 1; mOffset = '0px'; break;

            case CARD_TYPES.LEFT: mZIndex = 5; mScale = scale; mOpacity = opacity;
                mOffset = `50% - ${this.props.width * mScale / 2 - offset}px`; break;

            case CARD_TYPES.RIGHT: mZIndex = 5; mScale = scale; mOpacity = opacity;
                mOffset = `-50% + ${this.props.width * mScale / 2 - offset}px`; break;

            case CARD_TYPES.HIDDEN: mZIndex = 0; mScale = scale / 2; mOpacity = opacity / 2; mOffset = '0px'; break;
        }

        return {
            position: 'absolute', transform: `translateX(calc(${mOffset})) scale(${mScale})`,
            zIndex: mZIndex, opacity: mOpacity,
            width, height,
        };
    }

}

Carousel.defaultProps = {
    initialIndex: 0,
    height: 350,
    width: 700,
    lateralProps: {
        offset: 200,
        scale: 0.75,
        opacity: 0.25,
    },
    components: [Testimonial, FewStepsAway, HotelOwners],
};